let MODULE_SRC = {};

if (
    process.env.REACT_APP_ENV === 'stg' ||
    process.env.REACT_APP_ENV === 'dev' ||
    process.env.REACT_APP_ENV === 'qa' ||
    process.env.REACT_APP_ENV === 'qa-preprod'
) {
    MODULE_SRC = {TIPS_AND_TUTORIALS: 'https://uwm.qa-rrp-backend.com/tipsandtutorials/index.html'};
}

if (process.env.REACT_APP_ENV === 'prod') {
    MODULE_SRC = {TIPS_AND_TUTORIALS: 'https://uwm.rrp-backend.com/tipsandtutorials/index.html'};
}

export default MODULE_SRC;
